const TYPEAHEAD_REGEXP = /^\s*([\S\s]+?)(?:\s+as\s+([\S\s]+?))?\s+for\s+([\w$]+)\s+in\s+([\S\s]+?)$/;

class MfParseDirective {
	/* @ngInject */
	/**
	 * @param {import('angular').IParseService} $parse
	 * @param {import('angular').IQService} $q
	 */
	constructor($parse, $q) {
		this.restrict = 'A';
		this.require = '^mf';
		this.scope = false;
		this.$parse = $parse;
		this.$q = $q;
	}

	/**
	 * @param {{ $parent: { $parent: any; }; }} scope
	 * @param {any} element
	 * @param {{ mfParse: any; }} attributes
	 * @param {import('./mf.controller').default} mfCtrl
	 */
	link(scope, element, attributes, mfCtrl) {
		mfCtrl.mfParse.enabled = true;

		const mfParseList = (/** @type {string} */ input) => {
			const match = input.match(TYPEAHEAD_REGEXP);
			if (!match) {
				throw new Error(
					'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"'
					+ ` but got "'}${input}".`,
				);
			}

			return {
				itemName:    match[3],
				source:      this.$parse(match[4]),
				viewMapper:  this.$parse(match[2] || match[1]),
				modelMapper: this.$parse(match[1]),
				list:        this.$parse(match[5]),
			};
		};

		this.parserResult = attributes.mfParse ? mfParseList(attributes.mfParse) : undefined;

		/** @type {any} */
		const locals = {};

		this.$q.when(this.parserResult?.list(scope.$parent, locals)).then(matches => {
			mfCtrl.mfParse.matches.length = 0;

			// transform labels
			if (this.parserResult && Array.isArray(matches)) {
				for (const match of matches) {
					locals[this.parserResult.itemName] = match.name;
					mfCtrl.mfParse.matches.push({
						kid:        match.kid,
						name:       this.parserResult.viewMapper(scope, locals) || match.name,
						selectable: 1,
						model:      match,
					});
				}
			}
			return this.$q.resolve();
		}).catch(error => console.error(error));

		mfCtrl.mfParse.parseFromSource = async (/** @type {any} */ localsSource) => {
			const matches = await this.$q.when(this.parserResult?.source(scope.$parent.$parent, localsSource));
			return {
				matches,
				parserResult: this.parserResult,
			};
		};
	}
}

const mfParseDirective = /* @ngInject */ (
	/** @type {import('angular').IParseService} */ $parse,
	/** @type {import('angular').IQService} */ $q,
) => new MfParseDirective($parse, $q);

export default mfParseDirective;
